import React from 'react';
import type { CampaignGenerationJob } from '../types';
import moment from 'moment';
import { Progress, Tag } from 'antd';
import { useForceIntervalUpdate } from 'hooks/useForceUpdate';

type Props = {
  campaignGenerationJob: CampaignGenerationJob,
};

const calculateProgressBasedOnElapsedTimeAndEstimatedTime = (
  elapsedTime: number,
  estimatedTime: number,
) => {
  if (estimatedTime === 0) {
    return 0;
  }
  return Math.min(99, Math.floor((elapsedTime / estimatedTime) * 100));
};

export default function CampaignGenerationStatus(props: Props) {
  const { campaignGenerationJob } = props;
  const {
    startedAt,
    completedAt,
    estimatedCompletionTime,
    status: campaignStatus,
  } = campaignGenerationJob;
  const elapsedTime = moment().diff(moment(startedAt), 'seconds');
  let progress;
  switch (campaignGenerationJob.status) {
    case 'processed':
      progress = 100;
      break;
    case 'failed':
      progress =
        (moment(completedAt).diff(moment(startedAt), 'seconds') /
          estimatedCompletionTime) *
        100;
      break;
    default:
      progress = calculateProgressBasedOnElapsedTimeAndEstimatedTime(
        elapsedTime,
        estimatedCompletionTime || 15 * 60,
      );
      break;
  }
  let progressStatus = 'active';
  if (campaignGenerationJob.status === 'processed') {
    progressStatus = 'success';
  } else if (campaignGenerationJob.status === 'failed') {
    progressStatus = 'exception';
  }
  useForceIntervalUpdate(campaignStatus === 'processing' ? 1000 : null);
  if (campaignStatus === 'pending') {
    return (
      <div className="flex items-center">
        <Tag color="orange" style={{ marginRight: 0 }}>
          PENDING
        </Tag>
      </div>
    );
  }
  return <Progress percent={progress} status={progressStatus} />;
}
